module.exports = __webpack_public_path__ + "static/media/norecord.52508176.png";